<template>
  <div class="case">
    <banner title="经典案例" subtitle="SUCCESSFUL CASES" />
    <div class="case-section" v-loading="loading">
      <div class="case-section-content">
        <div class="case-section-content-list" v-for="(cas,index) in caseList" :key="index">
          <div class="case-media">
            <img v-lazy="$img(cas.Img)" alt />
          </div>
          <div class="content-list-abstract" :class="{'abstract-active' : index%2!=1}">
            <p class="abstract-title">{{cas.Title}}</p>
            <p class="abstract-content">{{cas.Content}}</p>
            <div class="more">
              <router-link
                class="text-decoration"
                :to="{ name: 'casedetails', params: { id: cas.Id }}"
              >
                <span>了解详情</span>
                <i class="el-icon-arrow-right"></i>
              </router-link>
            </div>
          </div>
        </div>
        <div v-if="!loading && !caseList.length" class="empty-tip">暂无案例数据</div>
      </div>
    </div>
  </div>
</template>
<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner
  },
  data() {
    return {
      loading: true,
      caseList: []
    };
  },
  mounted() {
    this.$http
      .get("Case")
      .then(response => {
        this.caseList = response.data || [];
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  }
};
</script>

<style lang="scss" scoped>
.case {
  width: 100%;
  background: linear-gradient(180deg, #14679f 0%, #0f4f7d 100%);

  &-section {
    width: 100%;
    padding-bottom: 40px;

    &-content {
      width: 1240px;
      max-width: calc(100% - 32px);
      min-height: 520px;
      margin: -28px auto 0;
      background: #fff;
      border-radius: 16px;
      box-shadow: 0 -8px 30px rgba(8, 28, 46, 0.12);
      padding: 36px 40px 50px;
      position: relative;
      z-index: 1;

      &-list {
        width: 100%;
        min-height: 320px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 36px;
        padding: 28px 0;
        border-bottom: 1px solid #eef3f7;

        &:last-child {
          border-bottom: none;
        }

        .case-media {
          flex: 1;
          max-width: 620px;
          overflow: hidden;
          border-radius: 12px;
          box-shadow: 0 12px 28px rgba(15, 47, 74, 0.12);

          img {
            width: 100%;
            height: 320px;
            object-fit: cover;
            display: block;
            transition: transform 0.4s ease;
          }

          &:hover img {
            transform: scale(1.03);
          }
        }

        .content-list-abstract {
          width: 320px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          gap: 18px;

          .abstract-title {
            margin: 0;
            line-height: 1.4;
            font-size: 24px;
            color: #17324a;
            font-weight: 600;
          }

          .abstract-content {
            margin: 0;
            max-height: 150px;
            color: #5d758a;
            font-size: 15px;
            line-height: 1.8;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 6;
            -webkit-box-orient: vertical;
          }

          .more .text-decoration {
            text-decoration: none;
            color: #1f6fab;
            font-size: 14px;
            display: inline-flex;
            align-items: center;
            gap: 4px;
          }
        }

        .abstract-active {
          order: -1;
        }
      }

      .empty-tip {
        text-align: center;
        color: #7a93a8;
        padding: 80px 0;
      }
    }
  }
}

@media (max-width: 960px) {
  .case-section-content {
    padding: 28px 20px 36px;
  }

  .case-section-content-list {
    flex-direction: column !important;
    gap: 18px;
    min-height: 0;
    padding: 22px 0;
  }

  .case-section-content-list .case-media {
    width: 100%;
    max-width: 100%;
  }

  .case-section-content-list .case-media img {
    height: 220px;
  }

  .case-section-content-list .content-list-abstract,
  .case-section-content-list .abstract-active {
    width: 100%;
    order: 0 !important;
  }
}

@media (max-width: 640px) {
  .case-section-content-list .abstract-title {
    font-size: 20px;
  }
}
</style>
